var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97204 0.0449219C6.00004 0.0449219 6.02804 0.0449219 6.02804 0.0729219C6.05604 0.520922 6.30804 3.60092 8.74404 4.97292C11.684 6.59692 11.964 9.73292 10.256 11.9169C10.032 12.2249 9.72404 12.4769 9.44404 12.7289C8.49204 13.4569 6.53204 14.6329 4.20804 13.7369C2.24804 12.9809 0.876035 11.1329 0.708035 9.03292C0.652035 8.19292 0.736035 7.26892 1.12804 6.26092C1.12804 6.23292 1.18404 6.23292 1.18404 6.26092C1.26804 6.65292 1.66004 8.22092 2.58404 8.92092C3.45204 9.56492 4.68404 9.17292 4.88004 8.10892C4.96404 7.60492 4.88004 6.84892 4.37604 5.78492C3.03204 2.92892 5.60804 0.380922 5.97204 0.0449219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.e822f0ce.svg";
export { ForwardRef as ReactComponent };